import axios from "./request";

const BasicParams = {
 
};

export default {
 //获取token
  gettoken() {
    return axios
      .post("/ibmp/sys/getToken",  
         {
        secretId: "782",
		secretKey: "lmkdfuhd2ytojdh7vatw"
        }
      )
      .then((res) => res.data? res.data: []);
  },
  // 左上角--当前业务情况
  getcurrentBusinessSituation() {
    return axios
      .get("ibmp/dashboard/currentBusinessSituation", {
        params: {},
      })
  	  console.log('params',params)
      .then((res) => res.data? res.data: []);
  },
  
  //左中
  // 获取年度区县新规模排名
  getYearCountySalesRank() {
    return axios
      .get("/ibmp/dashboard/getYearCountySalesRank", {
        params: {},
      })
      .then((res) => res.data? res.data: []);
  },
  // 获取年度区县新增金额占比
  districtAmountRatio() {
    return axios
      .get("/ibmp/dashboard/districtAmountRatio", {
        params: {},
      })
      .then((res) => res.data? res.data: []);
  },
  //左下
  // 按业务模式
  getByBusinessType() {
    return axios
      .get("ibmp/dashboard/getByBusinessType", {
        params: {},
      })
  	  console.log('params',params)
      .then((res) => res.data? res.data: []);
  },
  // 按担保金额
  getByGuaranteeAmount() {
    return axios
      .get("ibmp/dashboard/getByGuaranteeAmount", {
        params: {},
      })
  	  console.log('params',params)
      .then((res) => res.data? res.data: []);
  },
  
  // 中下  资产营收卡片
  assetRevenue() {
    return axios
      .get("ibmp/dashboard/assetRevenue", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 存量资产分类统计
  stockAssetCategory() {
    return axios
      .get("ibmp/dashboard/stockAssetCategory", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 不良资产包性质占比
  nonPerformingAssetType() {
    return axios
      .get("ibmp/dashboard/nonPerformingAssetType", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 不良资产案件状态占比（追偿中/已结案）
  nonPerformingAssetStatus() {
    return axios
      .get("ibmp/dashboard/nonPerformingAssetStatus", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 股权资产持有股份&年度营收
  equityAssetHolding() {
    return axios
      .get("ibmp/dashboard/equityAssetHolding", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 股东占股比例
  equityShareholderRatio() {
    return axios
      .get("ibmp/dashboard/equityShareholderRatio", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 股权组织架构树
  equityOrgTree() {
    return axios
      .get("ibmp/dashboard/equityOrgTree", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  //中上  当日数据
  todayData() {
    return axios
      .get("ibmp/dashboard/todayData", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },
  
  //地图
  getCountryMapData() {
    return axios
      .get("ibmp/dashboard/getCountryMapData", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 地图 - 资产位置标记点
  getAssetMapMarkers() {
    return axios
      .get("ibmp/dashboard/getAssetMapMarkers", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 右下角轮播 - 地图标点资产列表
  mapMarkerAssetList() {
    return axios
      .get("ibmp/dashboard/mapMarkerAssetList", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 地图 - 各区存量资产数量统计
  districtAssetCount() {
    return axios
      .get("ibmp/dashboard/districtAssetCount", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

	//中下  客户类型
  debtorTypeData() {
    return axios
      .get("ibmp/dashboard/debtorTypeData", {
        params: {},
      })
  	  console.log('params',params)
      .then((res) => res.data? res.data: []);
  },
  //右上角
  // 行业规模分布
  getIndustryDistribution() {
    return axios
      .get("ibmp/dashboard/getIndustryDistribution", {
        params: {},
      })
  	  console.log('params',params)
      .then((res) => res.data? res.data: []);
  },
  
  //右中
  // 每月新增担保金额趋势
  getMonthlyAdditionTrend() {
    return axios
      .get("ibmp/dashboard/getMonthlyAdditionTrend", {
        params: {},
      })
  	  console.log('params',params)
      .then((res) => res.data? res.data: []);
  },
  
  
  //右下
  // 获取年度合作银行新增规模排名
  getYearBankSalesRank() {
    return axios
      .get("/ibmp/dashboard/getYearBankSalesRank", {
        params: {},
      })
      .then((res) => res.data? res.data: []);
  },
  // 获取年度合作银行新增金额占比
  bankYearlyAdditionRatio() {
    return axios
      .get("/ibmp/dashboard/bankYearlyAdditionRatio", {
        params: {},
      })
      .then((res) => res.data? res.data: []);
  },

  



  // 右栏 - 资产出租率分析（饼图+数量卡片）
  assetRentalRate() {
    return axios
      .get("/ibmp/dashboard/assetRentalRate", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 存量资产性质占比（横向柱图+环形饼图）
  stockAssetNature() {
    return axios
      .get("/ibmp/dashboard/stockAssetNature", {
        params: {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 存量资产分类列表（点击房产/土地/土地及附着物时调用，必须传 assetCategory）
  // assetCategory: HOUSE | LAND | LAND_ATTACHMENT
  stockAssetListByCategory(assetCategory) {
    return axios
      .get("/ibmp/asset/stockAssetListByCategory", { params: { assetCategory } })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 存量资产按资产性质筛选（点击存量资产性质占比图时调用）
  // assetNature: INTERNAL | EXTERNAL | OWN | RENTAL | OTHER
  stockAssetListByAssetNature(assetNature) {
    return axios
      .get("/ibmp/asset/stockAssetListByAssetNature", { params: { assetNature } })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 存量资产按出租状态筛选（点击资产出租率饼图时调用）
  // rentalStatus: WAITING | PARTIAL | FULL | OTHER
  stockAssetListByRentalStatus(rentalStatus) {
    return axios
      .get("/ibmp/asset/stockAssetListByRentalStatus", { params: { rentalStatus } })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 出租明细（地块+位置+状态嵌套结构，点击待出租/部分出租/已出租时调用）
  // rentalStatus: WAITING | PARTIAL | FULL
  rentalDetail(rentalStatus) {
    return axios
      .get("/ibmp/asset/rentalDetail", { params: { rentalStatus } })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 不良资产按性质筛选（点击不良资产包性质占比图时调用）
  // assetPackType: OWN | AGENT | PURCHASE | OTHER
  nonPerformingAssetListByType(assetPackType) {
    return axios
      .get("/ibmp/asset/nonPerformingAssetListByType", { params: { assetPackType } })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 不良资产按类别名称筛选（点击柱状图时调用，与柱状图统计口径一致）
  nonPerformingAssetListByCategory(categoryName) {
    return axios
      .get("/ibmp/asset/nonPerformingAssetListByCategory", { params: { categoryName } })
      .then((res) => res.data ? res.data : []);
  },

  // 按案件状态筛选不良资产列表（0=追偿中, 1=已结案）
  nonPerformingAssetListByCaseStatus(caseStatus) {
    return axios
      .get("/ibmp/asset/nonPerformingAssetListByCaseStatus", { params: { caseStatus } })
      .then((res) => res.data ? res.data : []);
  },

  // 左栏 - 存量资产分类列表（按 NonResidentialType 编码筛选，点击分类卡片时调用）
  // nonResidentialType: 1319/1320/1001409/1001410/1001411/1001412/1001413/1001414/1001415/1001416
  stockAssetListByNonResidentialType(nonResidentialType) {
    return axios
      .get("/ibmp/asset/stockAssetListByNonResidentialType", { params: { nonResidentialType } })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 存量资产轮播列表（assetCategory 按分类筛选，rentalStatus 按出租状态筛选，assetNature 按资产性质筛选）
  stockAssetList(assetCategory, rentalStatus, assetNature) {
    const params = {};
    if (assetCategory) params.assetCategory = assetCategory;
    if (rentalStatus) params.rentalStatus = rentalStatus;
    if (assetNature) params.assetNature = assetNature;
    return axios
      .get("/ibmp/asset/stockAssetList", { params })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 不良资产轮播列表（assetPackType 可选，传入则按资产包性质筛选）
  nonPerformingAssetList(assetPackType) {
    return axios
      .get("/ibmp/asset/nonPerformingAssetList", {
        params: assetPackType ? { assetPackType } : {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 股权资产轮播列表（companyName 可选，传入则按被投企业名称筛选）
  equityAssetList(companyName) {
    return axios
      .get("/ibmp/asset/equityAssetList", {
        params: companyName ? { companyName } : {},
      })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 模糊搜索资产（按名称或编码，跨存量/不良/股权三类）
  searchAssets(keyword) {
    return axios
      .get("/ibmp/asset/searchAssets", { params: { keyword } })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 枣庄银行股权划转进度（柱状图+明细弹窗）
  zzBankEquityTransferDetail() {
    return axios
      .get("/ibmp/dashboard/zzBankEquityTransferDetail", { params: {} })
      .then((res) => res.data ? res.data : []);
  },

  // 右栏 - 代管集团投资股权收益（折线图+明细弹窗）
  managedGroupEquityIncomeDetail() {
    return axios
      .get("/ibmp/dashboard/managedGroupEquityIncomeDetail", { params: {} })
      .then((res) => res.data ? res.data : []);
  },

  // KPI 手动配置 - 查询五个可调整字段当前值
  kpiConfig() {
    return axios
      .get("/ibmp/dashboard/kpiConfig", { params: {} })
      .then((res) => res.data ? res.data : []);
  },

  // KPI 手动配置 - 更新单个字段
  // body: { fieldKey: string, fieldValue: number }
  updateKpiConfig(body) {
    return axios
      .put("/ibmp/dashboard/kpiConfig", body)
      .then((res) => res.data ? res.data : []);
  },

  // 破产企业职工权益兑付（地图标点+右侧卡片）
  bankruptEmpRightsPay() {
    return axios
      .get("/ibmp/dashboard/bankruptEmpRightsPay", { params: {} })
      .then((res) => res.data ? res.data : []);
  },

  getMapMarks(isDetail = 0) {
    return axios
      .get("LocationInfo/GetLocationInfoList", {
        params: {
          ...BasicParams,
          IsShowDetail: isDetail,
        },
      })
      .then((res) => {
        return (res?.data?.data || []).map((item) => {
          return {
            show: item.IsShowDetail === "1",
            longitude: item.Longitude,
            latitude: item.Latitude,
            id: item.GUID,
            type: item.LocationTypeId,
            name: item.Description,
          };
        });
      });
  },
};
